<script setup>
// Aba Template da caixa WhatsApp Cloud (id 1 + e-mails MetaAccess): lista os
// templates AO VIVO da Meta (mesmo status do gerenciador) + botao Criar
// Template. A tabela vive em TemplatesTable.vue (reusada no menu Meta).
import { ref, onMounted } from 'vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import InboxTemplatesAPI from 'dashboard/api/inboxTemplates';
import CreateTemplateModal from '../components/CreateTemplateModal.vue';
import TemplatesTable from '../components/TemplatesTable.vue';

const props = defineProps({
  inbox: {
    type: Object,
    required: true,
  },
});

const templates = ref([]);
const isLoading = ref(false);
const loadError = ref('');
const showCreateModal = ref(false);

const fetchTemplates = async () => {
  isLoading.value = true;
  loadError.value = '';
  try {
    const { data } = await InboxTemplatesAPI.listTemplates(props.inbox.id);
    templates.value = data.data || [];
  } catch (e) {
    loadError.value = e?.response?.data?.error || e.message;
  } finally {
    isLoading.value = false;
  }
};

const onTemplateCreated = () => {
  showCreateModal.value = false;
  fetchTemplates();
};

onMounted(fetchTemplates);
</script>

<template>
  <div class="mx-6">
    <div class="flex items-start justify-between mb-6 gap-4">
      <div>
        <h2 class="text-heading-2 text-n-slate-12 mb-1">Templates da caixa</h2>
        <p class="text-n-slate-11 text-sm">
          Lista consultada ao vivo na Meta com as credenciais desta caixa — o
          status é o mesmo do gerenciador do WhatsApp.
        </p>
      </div>
      <div class="flex gap-2 shrink-0">
        <NextButton
          variant="outline"
          color="slate"
          label="Atualizar"
          :is-loading="isLoading"
          @click="fetchTemplates"
        />
        <NextButton label="Criar Template" @click="showCreateModal = true" />
      </div>
    </div>

    <p
      v-if="loadError"
      class="text-sm text-n-ruby-11 mb-4 whitespace-pre-wrap"
    >
      {{ loadError }}
    </p>

    <div
      v-if="isLoading && !templates.length"
      class="text-sm text-n-slate-11 py-8 text-center"
    >
      Carregando templates da Meta…
    </div>

    <div
      v-else-if="!templates.length && !loadError"
      class="text-sm text-n-slate-11 py-8 text-center"
    >
      Nenhum template encontrado nesta conta WhatsApp Business.
    </div>

    <TemplatesTable v-else :templates="templates" />

    <CreateTemplateModal
      v-if="showCreateModal"
      :inbox="inbox"
      @close="showCreateModal = false"
      @created="onTemplateCreated"
    />
  </div>
</template>
